import { render, staticRenderFns } from "./BroadcastDescription.vue?vue&type=template&id=75ea2871&"
import script from "./BroadcastDescription.vue?vue&type=script&lang=js&"
export * from "./BroadcastDescription.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastDescription.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports